import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "./firebase";

export const uploadExibicaoImage = async (
  file: File | null,
  userId: string,
  deviceId: string,
  oldFileUrl?: string
): Promise<string> => {
  if (oldFileUrl) {
    try {
      const oldFileRef = ref(storage, oldFileUrl);
      await deleteObject(oldFileRef);
      console.log("Imagem de exibição antiga deletada com sucesso.");
    } catch (error: any) {
      if (error.code !== 'storage/object-not-found') {
        console.error("Erro ao deletar a imagem de exibição antiga:", error);
      }
    }
  }

  if (!file) {
    return "";
  }
  
  const filePath = `clientes/${userId}/exibicao/${deviceId}/${file.name}`;
  const newFileRef = ref(storage, filePath);
  
  await uploadBytes(newFileRef, file);
  const downloadURL = await getDownloadURL(newFileRef);

  return downloadURL;
};
